export const contactUsForm = {
  default: {
    title: {
      label: 'Send us a message',
      translationKey: 'send_us_a_msg',
    },
    twoCol: false,
    hasReCAPTCHA: false,
    fields: [
      {
        label: 'Name',
        id: 'name',
        type: 'text',
        placeholder: {
          label: 'Your Name',
          translationKey: 'name_placeholder',
        },
        translationKey: 'name_translation',
        twoCol: true,
      },
      {
        label: 'Email Address',
        id: 'email',
        type: 'email',
        placeholder: {
          label: 'email@email.com',
          translationKey: 'email_placeholder',
        },
        translationKey: 'email_translation',
        twoCol: true,
      },
      {
        label: 'Subject',
        id: 'subject',
        type: 'text',
        placeholder: {
          label: 'What is it about?',
          translationKey: 'subject_placeholder',
        },
        translationKey: 'subject_translation',
        twoCol: true,
      },
      {
        label: 'Message',
        id: 'message',
        type: 'textarea',
        placeholder: {
          label: 'Write something',
          translationKey: 'message_placeholder',
        },
        translationKey: 'message_translation',
        maxLength: '1000',
      },
      {
        id: 'tnc',
        type: 'checkbox',
        required: true,
        translationKey: 'checkbox_translation',
        options: [
          {
            id: 'tnc',
            link: {
              url: '/privacy-policy',
              text: 'Privacy',
              translationKey: 'contact_checkbox',
            },
            translationKey: 'option_one_translation',
          },
        ],
      },
    ],
  },
};

export const newsLetterForm = {
  default: {
    title: {
      label: 'Get in on the action',
      translationKey: 'newsletter_form_main_text',
    },
    description: {
      label: 'Sign up now for the latest bonuses, promotions, and new online casinos.',
      translationKey: 'newsletter_form_subscribe_text',
    },
    twoCol: false,
    hasReCAPTCHA: false,
    fields: [
      {
        label: 'Name',
        id: 'name',
        type: 'text',
        placeholder: {
          label: 'Name',
          translationKey: 'newsletter_form_first_name_placeholder',
        },
        translationKey: 'newsletter_form_first_name_text',
        twoCol: true,
        required: true,
      },
      {
        label: 'Email',
        id: 'email',
        type: 'email',
        placeholder: {
          label: 'Email',
          translationKey: 'newsletter_form_email_placeholder',
        },
        translationKey: 'newsletter_form_email_text',
        twoCol: true,
        required: true,
      },
      {
        label: '',
        id: 'checkbox1',
        type: 'checkbox',
        twoCol: false,
        options: [
          {
            id: 'checkbox1',
            label: 'I confirm I am over 18 years old.',
            translationKey: 'newsletter_form_privacy_text_1',
            required: true,
          },
        ],
      },
      {
        label: '',
        id: 'checkbox2',
        type: 'checkbox',
        twoCol: false,
        options: [
          {
            id: 'checkbox2',
            label:
              ' I agree that my contact data may be used to keep me informed about casino products, services and offerings. ',
            translationKey: 'newsletter_form_privacy_text_2',
            required: true,
          },
        ],
      },
      {
        label: '',
        id: 'checkbox3',
        type: 'checkbox',
        twoCol: false,
        options: [
          {
            id: 'checkbox3',
            label:
              '+18 Lorem ipsum dolor sit amet consectetur. Egestas nibh ullamcorper venenatis vulputate. Sed elit diam at id feugiat orci ornare Privacy Policy',
            translationKey: 'newsletter_form_privacy_text_3',
          },
        ],
      },
    ],
  },
};
